import React from "react";
import "./AboutUs.css";
import aboutusImg from "../Assets/aboutus-img.png";
import Founder from "./Founder";
import Team from "./Team";
import mission from "../Assets/mission.svg";
import mission2 from "../Assets/misson2.svg";
import mission3 from "../Assets/misson3.svg";
// import angel1 from "../Assets/angel1.png";
import angel1 from "../Assets/Vector.svg";
import TelegramCommunity from "./TelegramCommunity";
import mastercard from "../Assets/mastercard.png";
import DefaultLayout from "../../layouts/DefaultLayout";

const AboutUs = () => {
  return (
    <>
      <DefaultLayout>
        <div>
          <div className="aboutus">
            <div className="aboutus__hero">
              <div className="aboutus__box">
                <span className="aboutus__badge">Why Invest With Us ?</span>
                <span className="aboutus__header--text">
                  Where Do We Invest Your Money!
                </span>
                <span className="aboutus__header--footer">
                  At OVest, we invest in the following businesses:
                </span>

                <img src={aboutusImg} alt="" className="aboutus--image" />
                <div className="reasons-why-you-invest">
                  <p className="aboutus__smallBusiness">Small Businesses</p>
                  <p className="aboutus__realestate">
                    Real Estate Development and Management
                  </p>
                  <p className="aboutus__moneymarket">
                    Money Market (Forex and Crypto Manned by Professional
                    Traders )
                  </p>
                  <p className="aboutus__autos">
                    {" "}
                    Autos and other profitable investment opportunities offered
                    by the industry
                  </p>
                  <p className="aboutus__agric">
                    Agriculture (Farming Business)
                  </p>
                </div>
              </div>
            </div>

            <div className="aboutus__hero-sub">
              <div className="aboutus__hero-sub-sess">
                <div className="mission">
                  <img src={mission} alt="" />
                  <span className="mission-header">Our Mission</span>
                  <strong className="mission-body">
                    Our Mission is to help individuals , organization and
                    communities achieve financial security, build wealth and
                    realize their dreams.
                  </strong>
                </div>
                <div className="mission">
                  <img src={mission2} alt="" />

                  <span className="mission-header">Our Vision</span>
                  <strong className="mission-body">
                    To be the leading global financial platform that is 100%
                    trusted and reliable,suitable to add values to the entire
                    human race irrespective of financial capablities and income.
                  </strong>
                </div>{" "}
                <div className="mission">
                  <img src={mission3} alt="" />

                  <span className="mission-header">Our Value</span>
                  <strong className="mission-body">
                    <p>
                      <strong> CLIENT CENTRIC</strong>
                    </p>
                    <p>
                      <strong>COMPLIANCE</strong>
                    </p>
                    <p>
                      <strong>CONFIDENTIALITY</strong>
                    </p>

                    <p>
                      <strong>INNOVATIVE</strong>
                    </p>
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <Founder />
          <Team />
          <div className="top-vestors">
            <div className="top-ovesters">
              <p className="aboutus__badge1 ">Top OVestors</p>
              <h2>OVest is growing. Grow with us.</h2>
            </div>
            <div className="topvestors-cards">
              <div className="topvestors-card mb-4">
                <p>
                  I appreciate your transparency in your investment company and
                  I pray that the higher you go, the more prosperous it will be
                  for you in Jesus’ name. The company will not be a story of the
                  past in Jesus name.
                </p>
                <div className="card-f">
                  <img src={angel1} alt="" />
                  <div className="angel-detials">
                    <h4>Mrs Kayode Foluke </h4>
                    <p>OVestor, Lagos, Nigeria</p>
                  </div>
                </div>
              </div>
              <div className="topvestors-card">
                <p>
                  Thanks to OVest. I just saw the ROI.God continue to elevate
                  the company. With OVest, there is no cause for alarm.
                </p>
                <div className="card-f">
                  <img src={angel1} alt="" />
                  <div className="angel-detials">
                    <h4>Bamidele Israel</h4>
                    <p>OVestor, Benin Republic</p>
                  </div>
                </div>
              </div>
              <div className="topvestors-card">
                <p>
                  OVest will never die. Thanks so much. This is an impression
                  that will last forever. Long live OVest, Long live OSource.
                </p>
                <div className="card-f">
                  <img src={angel1} alt="" />
                  <div className="angel-detials">
                    <h4>Mide Fash </h4>
                    <p>OVestor, Ekiti, Nigeria.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TelegramCommunity />

          <div className="payment-method">
            <h2 className="h2">FEATURED PAYMENT METHOD</h2>
            <div className="mastercard">
              <img src={mastercard} alt="" />
              <img src={mastercard} alt="" />
              <img src={mastercard} alt="" />
              <img src={mastercard} alt="" />
              <img src={mastercard} alt="" />
              <img src={mastercard} alt="" />
            </div>
          </div>
        </div>

        {/* <Footer /> */}
      </DefaultLayout>
    </>
  );
};

export default AboutUs;
